module.exports = __webpack_public_path__ + "ae63e8c37b63ce4bce5c1cdc7e08a2b2.png";